export default __webpack_public_path__ + "static/media/boardroom.a263c4a3.svg";